import { render } from "./AdminUserCreationScreen.vue?vue&type=template&id=218fcd56&scoped=true"
import script from "./AdminUserCreationScreen.vue?vue&type=script&lang=js"
export * from "./AdminUserCreationScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=218fcd56&lang=scss&scoped=true"
import "./AdminUserCreationScreen.vue?vue&type=style&index=1&id=218fcd56&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218fcd56"]])

export default __exports__